<template>
  <div id="app" :class="classIndex">
    <loader></loader>
    <app-welcome v-if="userLogged.profile == 'HIJO'"></app-welcome>
    <app-arkidians v-if="userLogged.profile == 'PADRE'"></app-arkidians>
    <app-continue-watching v-if="userLogged.profile == 'HIJO'"></app-continue-watching>
    <app-inicial v-if="!userLogged.profile"></app-inicial>
    <app-proyectos v-if="!userLogged.profile"></app-proyectos>
    <app-categories-grid v-if="userLogged.profile != 'ADMINISTRADOR'"></app-categories-grid>
    <app-challenge v-if="!userLogged.profile"></app-challenge>
    <app-share v-if="!userLogged.profile"></app-share>
    <app-benefits v-if="!userLogged.profile"></app-benefits>
    <app-comments v-if="!userLogged.profile"></app-comments>
    <app-faqs v-if="!userLogged.profile"></app-faqs>
    <app-footer v-if="!userLogged.profile"></app-footer>
    <app-admin v-if="userLogged.profile == 'ADMINISTRADOR'"></app-admin>
    <app-latest-challenges v-if="userLogged.profile == 'HIJO'"></app-latest-challenges>
  </div>
</template>

<script>
import Loader from "./shared/Loader";
import Welcome from "../components/startPage/Welcome";
import ContinueWatching from "../components/startPage/ContinueWatching";
import CategoriesGrid from "../components/categories/CategoriesGrid.vue";
import Inicial from "../components/startPage/Inicial";
import ProjectBanner from "../components/startPage/ProjectBanner";
import ChallengeBanner from "../components/startPage/ChallengeBanner";
import ShareBanner from "../components/startPage/ShareBanner";
import BenefitsBanner from "../components/startPage/BenefitsBanner";
import CommentsBanner from "../components/startPage/CommentsBanner";
import Faqs from "../components/startPage/Faq";
import Footer from "../components/startPage/Footer";
import AdminPanel from "../components/admin/AdminPanel";
import LatestChallenges from "../components/startPage/LatesChallenges";
import Arkidians from "../components/startPage/Arkidians";
import { mapGetters } from "vuex";

export default {
  name: "app",
  data() {
    return {
      classIndex: ""
    };
  },
  methods: {
    hacerLoginToken(usuario, token) {
      console.log("el usuario es " + usuario);
      console.log("el token es " + token);
      sessionStorage.setItem("t", token);
      this.buscarPerfil(usuario);
      //this.cantidadNotificaciones(usuario);
      //this.agregarUsuarioCookie(usuario);
    },
    buscarPerfil(usuario) {
      console.log(usuario);
      fetch(this.$store.state.pathAPI + "perfil_usuario.php?usuario=" + usuario)
        .then(response => response.json())
        .then(data => {
          console.log(data);
          console.log(this.$store.state.userLogged);

          if (data.profile == "HIJO" || data.tipo == "HIJO") {
            this.$store.state.userLogged.preferencias.avatar = data.avatar;
            this.$store.state.userLogged.avatar = data.avatar;
            this.$store.state.userLogged.profile = "HIJO";
            this.$store.state.userLogged.name = data.alias;
            this.$store.state.userLogged.user = usuario;
            this.$store.state.userLogged.preferencias.animated = true;
            if (data.arkidian_usuario.length > 0) {
              this.$store.state.userLogged.preferencias.color =
                "fill:#" + data.arkidian_usuario[0].color;
              this.$store.state.userLogged.preferencias.body =
                data.arkidian_usuario[0].cuerpo;
              this.$store.state.userLogged.preferencias.hair =
                data.arkidian_usuario[0].pelo;
              this.$store.state.userLogged.preferencias.face =
                data.arkidian_usuario[0].cara;
            } else {
              this.$store.state.userLogged.preferencias.color = "";
              this.$store.state.userLogged.preferencias.body = "";
              this.$store.state.userLogged.preferencias.hair = "";
              this.$store.state.userLogged.preferencias.face = "";
            }
            console.log("entrando como hijo");
            console.log(this.$store.state.userLogged);
          } else {
            console.log(usuario);
            this.$store.state.userLogged.user = usuario;
            this.$store.state.userLogged.profile = data.tipo;
            this.$store.state.userLogged.name = data.nombre;
          }
          if (this.userLogged.profile == "HIJO") {
            this.classIndex = "index-kids";
          } else if (this.userLogged.profile == "PADRE") {
            this.classIndex = "index-other";
          }
        });
    }
  },
  computed: {
    ...mapGetters(["categorias", "userLogged"])
  },
  components: {
    Loader: Loader,
    appCategoriesGrid: CategoriesGrid,
    appInicial: Inicial,
    appProyectos: ProjectBanner,
    appChallenge: ChallengeBanner,
    appShare: ShareBanner,
    appBenefits: BenefitsBanner,
    appComments: CommentsBanner,
    appFaqs: Faqs,
    appFooter: Footer,
    appAdmin: AdminPanel,
    appWelcome: Welcome,
    appContinueWatching: ContinueWatching,
    appLatestChallenges: LatestChallenges,
    appArkidians: Arkidians
  },

  mounted: function() {
    if (!this.$store.state.userLogged.user) {
      console.log("recuperandoToken" + sessionStorage.getItem("t"));

      fetch(
        this.$store.state.pathAPI +
          "token.php?token=" +
          sessionStorage.getItem("t")
      )
        .then(response => response.json())
        .then(data => {
          if (data.resultado != "ERROR") {
            console.log("login token");
            console.log(data);
            this.hacerLoginToken(data.usuario, sessionStorage.getItem("t"));
          }
        });
    }

    if (this.userLogged.profile == "HIJO") {
      this.classIndex = "index-kids";
    } else if (this.userLogged.profile == "PADRE") {
      this.classIndex = "index-other";
    }
    const loader = document.querySelector(".loader");
    loader.className += " hidden";
  }
};
</script>

<style>
#welcome {
  background: url("/public/images/site/background-welcome.svg") no-repeat 50%
    50%;
  background-color: #0cb9c9;
  display: table;
  height: 100%;
  width: 100%;
  background-position-y: bottom;
  background-size: cover;
}

.index-kids {
  background-image: url(/public/images/site/index-background.svg);
  background-repeat: no-repeat;
  background-size: 100%;
  text-align: -webkit-center;
  display: table;
  position: relative;
  width: 100%;
}

.index-other {
  background-image: url(/public/images/site/index-other-background.svg);
  background-repeat: no-repeat;
  background-size: 100%;
  text-align: -webkit-center;
  display: table;
  position: relative;
  width: 100%;
}

.profile-background {
  background-image: url(/public/images/site/profile-background.svg);
  background-repeat: no-repeat;
  background-size: 100%;
  text-align: -webkit-center;
  display: table;
  position: relative;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue